import * as Yup from "yup";

export const codeSchema = Yup.string()
  .trim()
  .transform((v) => (v ? v.toUpperCase() : v))
  .min(4, "Code must be at least 4 characters")
  .max(50, "Code must be at most 50 characters")
  .matches(
    /^[A-Za-z0-9][A-Za-z0-9\-_/&]*[A-Za-z0-9]$/,
    "Code must start and end with a letter or number, and may only contain letters, numbers, hyphens, underscores, slashes, or &",
  )
  .nullable()
  .optional();

export const emailSchema = Yup.string()
  .matches(
    /^(?!.*\.\.)[a-zA-Z0-9]([a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
    "Invalid email format — use the format user@example.com",
  )
  .required("The email field is required");

export const phoneNumberSchema = Yup.string()
  .matches(
    /^[+\d\s]+$/,
    "Phone number may only contain digits, spaces, and a leading +",
  )
  .max(20, "Phone number must be 20 characters or fewer")
  .required("The phone number field is required");

export const passwordSchema = Yup.string()
  .required("Password is required")
  .min(8, "Password must be at least 8 characters long")
  .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
  .matches(/[a-z]/, "Password must contain at least one lowercase letter")
  .matches(/\d/, "Password must contain at least one number");

export const nameSchema = {
  firstName: Yup.string()
    .trim()
    .matches(/^[A-Za-z\s'-]+$/, "First name can only contain letters")
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be at most 50 characters")
    .required("The first name field is required"),

  lastName: Yup.string()
    .trim()
    .matches(/^[A-Za-z\s'-]+$/, "Last name can only contain letters")
    .min(1, "Last name must be at least 1 character")
    .max(50, "Last name must be at most 50 characters")
    .required("The last name field is required"),
};

export const fullNameSchema = Yup.string()
  .trim()
  .matches(/^[A-Za-z ]+$/, "Only alphabets and spaces are allowed")
  .min(2, "Full name must be at least 2 characters")
  .max(50, "Full name must not exceed 50 characters")
  .required("The full name field is required");

const gstRegExp = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const gstNumberSchema = Yup.string()
  .length(15, "GST number must be exactly 15 characters")
  .matches(gstRegExp, "Invalid GST number format");

export const websiteUrlSchema = Yup.string().url(
  "Please enter a valid URL (e.g., https://example.com)",
);

export const addressSchema = Yup.string()
  .trim()
  .min(3, "Address must be at least 3 characters")
  .required("The address field is required");

export const citySchema = Yup.string()
  .trim()
  .min(3, "City must be at least 3 characters")
  .required("The city field is required");

export const stateSchema = Yup.string()
  .trim()
  .min(3, "State must be at least 3 characters")
  .required("The state field is required");
